define('flight-components/ui/Popover',[
  'flight/lib/component',
  'flight-components/mixins/withPopover',
],

function(defineComponent, withPopover){

  var Popover = function Popover() {


    this.defaultAttrs({

    });

    this.after('initialize', function() {

    });

  };

  return defineComponent(Popover, withPopover);
});
